export default "__VITE_ASSET__C6uNGh$E__"